module.exports = {
      id: "icon-playstore-usage",
      viewBox: "0 0 190.654 62.305",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-playstore",
      toString: function () {
        return this.url;
      }
    }